export enum Priority {
  VeryHigh = 'VERY_HIGH',
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW',
  VeryLow = 'VERY_LOW'
}
